import { render } from "./CreateAccount.vue?vue&type=template&id=8fcbd156&scoped=true&ts=true"
import script from "./CreateAccount.vue?vue&type=script&lang=ts"
export * from "./CreateAccount.vue?vue&type=script&lang=ts"

import "./CreateAccount.vue?vue&type=style&index=0&id=8fcbd156&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fcbd156"]])

export default __exports__